import React from 'react'
import { QberaaMainTitle, QmainRow, QberaaMainsubTitle, QmainCol, QberaaMaintext, QberaaMainRedBox, QberaaAppImg, QberaaTopSection, BackGroundVideo } from './StyledComponents'
import { qberaaMain } from '../../../data/websiteData'
import { Grid, Row, Col } from '../../../styles/GlobalTheme/GlobalStyledComponents';
import dashboardImg from '../../../assets/home/bgImage.png'
import dashboardMImg from '../../../assets/home/BgMobil.png'
import bgVedio from '../../../assets/home/bg5.mp4'
import Fade from 'react-reveal/Fade';

const QberaaMain = () => {

    function getImg() {
        let imgSrc = dashboardImg;
        if (window.innerWidth <= 425) {
            imgSrc = dashboardMImg;
        } 
        return imgSrc;
    }

    return (
        <QberaaTopSection>
            <BackGroundVideo autoPlay="autoplay" loop="loop" muted className="VideoBox" >
                <source src={bgVedio} type="video/mp4" />
                Your browser does not support the video tag.
                </BackGroundVideo>
            <QmainCol>
                <QmainRow>
                    <Col>
                        <QberaaMainTitle>{qberaaMain.title}</QberaaMainTitle>
                        <QberaaMainRedBox></QberaaMainRedBox>
                    </Col>
                    <QberaaAppImg src={ getImg()}></QberaaAppImg>
                </QmainRow>
                <Fade bottom cascade duration={1000}>
                    <QberaaMainsubTitle>{qberaaMain.subTitle}</QberaaMainsubTitle>
                    <QberaaMaintext>{qberaaMain.content}</QberaaMaintext>
                </Fade>
            </QmainCol>
        </QberaaTopSection>
    )
}

export default QberaaMain
